import React, { useRef } from 'react';
import { useScroll } from 'framer-motion';
import { ScrollRevealWord } from './ScrollRevealWord';
type ScrollRevealTextProps = {
  text: string;
  className?: string;
};
export function ScrollRevealText({
  text,
  className = ''
}: ScrollRevealTextProps) {
  const ref = useRef<HTMLHeadingElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start 0.85', 'end 0.5']
  });
  const words = text.split(' ');
  return <h2 ref={ref} className={className} data-id="element-411" data-mp="2wf4cvqge2np6">
      <span className="sr-only" data-id="element-412" data-mp="2rlt4vlzuc0vo">{text}</span>
      <span aria-hidden="true" data-id="element-413" data-mp="2rl0554zaubn1">
        {words.map((word, i) => <ScrollRevealWord key={`${word}-${i}`} word={word} progress={scrollYProgress} range={[i / words.length, (i + 1) / words.length]} data-id="element-414" data-mp="2mo9n4c3xp5yz" data-mpi={i} />)}
      </span>
    </h2>;
}